import React, { useRef, useState, useCallback } from 'react';
import cn from 'classnames';
import { debounce } from 'lodash';
import Suggestions from '../../../IndustriesPicker/Suggestions';
import classes from '../../index.module.scss';
import { FETCHING_DEBOUNCE } from '../../../IndustriesPicker/constants';
import { MPI_INDUSTRIES_FILTER_MAX_TAGS } from '../../../filters/shared/constants';
import { useIndustriesContext } from '../../../shared/IndustriesContext';

const useIndustryPicker = ({ values, hideTags, placeholder, isMobile }) => {
    const inputRef = useRef();
    const pickerContainerRef = useRef();
    const [inputValue, setInputValue] = useState('');
    const {
        getIndustryTitle,
        updateIndustrySuggestions,
        industrySuggestions: suggestions,
    } = useIndustriesContext();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const updateIndustrySuggestionsDebounced = useCallback(
        debounce(updateIndustrySuggestions, FETCHING_DEBOUNCE),
        [updateIndustrySuggestions]
    );

    const autocompleteRenderInput = ({ ref, className, ...props }) => (
        <Suggestions
            className={cn(
                className,
                classes.suggestions,
                isMobile && classes.suggestionsMobile
            )}
            values={values}
            suggestions={suggestions}
            inputRef={inputRef}
            pickerContainerRef={pickerContainerRef}
            ref={ref}
            isMobile={isMobile}
            {...props}
        />
    );

    const renderLayout = (tagComponents, inputComponent) => (
        <span ref={pickerContainerRef}>
            {tagComponents}
            {inputComponent}
        </span>
    );

    const tagsInputProps = {
        placeholder: hideTags ? placeholder : !values.length && placeholder,
        disabled: hideTags && values.length >= MPI_INDUSTRIES_FILTER_MAX_TAGS,
        hidden: !hideTags && values.length >= MPI_INDUSTRIES_FILTER_MAX_TAGS,
    };

    const tagProps = {
        getTagDisplayValue: getIndustryTitle,
    };

    const handleInputChange = (inputValue) => {
        setInputValue(inputValue);
        updateIndustrySuggestionsDebounced(inputValue);
    };

    return {
        tagsInputProps,
        tagProps,
        autocompleteRenderInput,
        inputValue,
        handleInputChange,
        inputRef,
        renderLayout,
    };
};

export default useIndustryPicker;
